<template>
  <div>


    <b-container fluid class="header noselect">
      <b-row>
        <!-- Spacer Menu -->
        <b-col cols="2" class="d-lg-none text-left" align-self="center"></b-col>
        <!-- Logo -->
        <b-col cols="8" lg="2">
          <img class="p-2 mb-1 rounded-bottom logo mx-auto d-block" src="../../assets/img/easytick_color.png">
        </b-col>
        <!-- Sair Mobile -->
        <b-col cols="2" align-self="center" class="py-1 d-lg-none text-right">
          <p class="logout m-0">
            <router-link :to="{ name: 'Logout' }">
              <icon scale="1" name="power-off"></icon>
            </router-link>
          </p>
        </b-col>

        <!-- Evento -->
        <b-col cols="12" lg="8" align-self="center" class="my-2">
          <h1 class="title text-center m-0">
            {{ event.name }}
          </h1>
        </b-col>
        <!-- Sair Desktop -->
        <b-col lg="2" align-self="center" class="py-1 d-none d-lg-block text-right">
          <p class="logout m-0">
            <router-link :to="{ name: 'Logout' }">
              <icon scale="1" name="power-off"></icon>
            </router-link>
          </p>
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid>
      <b-row>
        <b-col cols="2" class="mmenu noselect pt-4">

          <h1>Principal</h1>
          <b-nav vertical class="mb-4 mt-1 rounded">
            <b-nav-item :to="{ name: 'DealerOverview' }" >
              <icon scale="0.9" name="eue"></icon> Visão Geral
            </b-nav-item>
          </b-nav>

          <h1>Ingressos</h1>
          <b-nav vertical class="mb-4 mt-1 rounded">
            <b-nav-item :to="{ name: 'DealerCreateTickets' }">
              <icon scale="0.9" name="print"></icon> Imprimir
            </b-nav-item>
            <b-nav-item :to="{ name: 'DealerListTickets' }">
              <icon scale="0.9" name="ticket-alt"></icon> Impressos
            </b-nav-item>
          </b-nav>
        </b-col>

        <b-col cols="10" style="min-height: calc(100vh - 95.17px)" class="pt-3">
          <router-view/>
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid class="footer">
      <b-row>
        <b-col>
          <p class="text-center my-2"><strong>Easytick</strong>, desde 2017 🎉</p>
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
export default {
  name: 'DealerDashboard',
  data () {
    return {
      event: ''
    }
  },
  async created () {
    const dealer = this.$route.params.dealer

    try {
      let login = await this.$http.post(process.env.VUE_APP_URL_APP + '/b/login', {
        dealer: dealer,
        platform: 'web'
      })

      let event = await this.$http.get(process.env.VUE_APP_URL_APP + `/b/dealers/${dealer}/events`)
      this.event = event.body

      // Preload logo
      let image = new Image()
      image.src = this.event.image

      console.log(login)
    } catch (err) {
      console.error(err)
    }
  }
}
</script>
